import React from 'react'
import FormROValue from '../../../library/form/components/FormROValue1';
import FormLabel from '../../../library/form/components/FormLabel'
import DocRowContainer from '../../cmn/DocRowContainer'
import { UiBox, UiCol } from "../../../library/layout/Index";

const ProfileBankRow = (props) => {
    const { formObject, rowKey } = props;

    return (
        <UiCol>
            <DocRowContainer formObject={formObject} rowKey={rowKey} >
                <UiBox>
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "accNum" }}
                            className="uiHeaderElement" id="svLandmark"
                        />
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "accName" }}
                            className="uiInline" id="svLandmark"
                        />
                        <div className="uiSpacer5">
                            <div className="uiRowHeight1">
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "delInst" }} value="Bank Name" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "bankName" }}
                                    className="uiInline" id="svLandmark"
                                />
                            </div>
                            <div className="uiRowHeight1">
                                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "remarks" }}
                                    className="uiInline" id="svLandmark"
                                />
                            </div>
                        </div>
                </UiBox>
            </DocRowContainer>
        </UiCol>
    )
}

export default ProfileBankRow